(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3623],{

/***/ 8064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50846);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Navbar = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            className: props.fixed ? "navbar fixed-top navbar-expand" : "navbar navbar-expand",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container-sm px-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "navbar-nav w-100 p-0 m-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "d-flex w-100 align-items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col px-0",
                                children: props.left
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-auto navbar-title text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "h3 mb-0 ".concat(props.titleClass),
                                        children: props.title
                                    }),
                                    props.subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                        className: "text-gray2 label-2",
                                        children: props.subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col d-flex justify-content-end px-0 text-end",
                                children: props.right
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Navbar);
Navbar.defaultProps = {
    title: "\xa0",
    fixed: true
};
Navbar.propTypes = {
    left: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
    right: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)
};


/***/ }),

/***/ 58082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ image_icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(2082);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
;// CONCATENATED MODULE: ./hooks/use_dynamic_svg.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function useDynamicSVGImport(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ImportedIconRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var onCompleted = options.onCompleted, onError = options.onError;
    (0,react.useEffect)(function() {
        setLoading(true);
        var importIcon = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return __webpack_require__(53780)("./".concat(name, ".svg"));
                        case 3:
                            ImportedIconRef.current = _ctx.sent.default;
                            if (onCompleted) {
                                onCompleted(name, ImportedIconRef.current);
                            }
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            if (onError) {
                                onError(_ctx.t0);
                            }
                            setError(_ctx.t0);
                        case 11:
                            _ctx.prev = 11;
                            setLoading(false);
                            return _ctx.finish(11);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7,
                        11,
                        14
                    ]
                ]);
            }));
            return function importIcon() {
                return _ref.apply(this, arguments);
            };
        }();
        importIcon();
    }, [
        name,
        onCompleted,
        onError
    ]);
    return {
        error: error,
        loading: loading,
        SvgIcon: ImportedIconRef.current
    };
};
;

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(50846);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/shared/image_icon.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var ImageIcon = function(props) {
    var ref = useDynamicSVGImport(props.name), SvgIcon = ref.SvgIcon, loading = ref.loading;
    var raw = props.raw, passProps = _objectWithoutProperties(props, [
        "raw"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.raw ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !loading && SvgIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon, _objectSpread({}, passProps))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/images/icons/".concat(props.name, ".svg"),
            alt: props.alt || props.name,
            width: props.width,
            height: props.height,
            className: props.className,
            title: props.name,
            layout: "raw"
        })
    });
};
ImageIcon.propTypes = {
    raw: (prop_types_default()).bool,
    name: (prop_types_default()).string.isRequired
};
ImageIcon.defaultProps = {
    raw: false,
    width: 32,
    height: 32
};
/* harmony default export */ var image_icon = (ImageIcon);


/***/ }),

/***/ 16828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "A0": function() { return /* binding */ getEmojiByStatus; },
/* harmony export */   "A6": function() { return /* binding */ setLocaleCookie; },
/* harmony export */   "Al": function() { return /* binding */ getMaxTextLengthByScreen; },
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "Fz": function() { return /* binding */ ISO_TIME_FORMAT_MINUTES; },
/* harmony export */   "Hm": function() { return /* binding */ goBack; },
/* harmony export */   "LS": function() { return /* binding */ generateRange; },
/* harmony export */   "Lk": function() { return /* binding */ address; },
/* harmony export */   "M9": function() { return /* binding */ userSetupStatusRedirect; },
/* harmony export */   "Mr": function() { return /* binding */ ONLY_TIME_FORMAT; },
/* harmony export */   "OV": function() { return /* binding */ shorten; },
/* harmony export */   "S_": function() { return /* binding */ isAndroidApp; },
/* harmony export */   "TB": function() { return /* binding */ usersGroupsStatuses; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Us": function() { return /* binding */ MAX_DESCRIPTION_LENGTH; },
/* harmony export */   "Vn": function() { return /* binding */ isFalsey; },
/* harmony export */   "Z8": function() { return /* binding */ parseUserActivities; },
/* harmony export */   "ZG": function() { return /* binding */ ICON_SIZE; },
/* harmony export */   "_T": function() { return /* binding */ generateEventName; },
/* harmony export */   "aD": function() { return /* binding */ REGISTRATION_STEPS; },
/* harmony export */   "c2": function() { return /* binding */ ISO_DATE_FORMAT; },
/* harmony export */   "c9": function() { return /* binding */ langugageEmojiMapper; },
/* harmony export */   "d0": function() { return /* binding */ REDIRECT_URL_REGEX; },
/* harmony export */   "fB": function() { return /* binding */ activityLevels; },
/* harmony export */   "fQ": function() { return /* binding */ isTruthy; },
/* harmony export */   "gc": function() { return /* binding */ groupNewResourceLink; },
/* harmony export */   "hL": function() { return /* binding */ isReactNativeApp; },
/* harmony export */   "hb": function() { return /* binding */ scrollWindowToTop; },
/* harmony export */   "k6": function() { return /* binding */ isIOSApp; },
/* harmony export */   "kC": function() { return /* binding */ capitalize; },
/* harmony export */   "kw": function() { return /* binding */ getAfterSignInPath; },
/* harmony export */   "lq": function() { return /* binding */ appendURLParam; },
/* harmony export */   "qb": function() { return /* binding */ DATE_WORD_FORMAT; },
/* harmony export */   "ql": function() { return /* binding */ MAX_TEXTAREA_LENGTH; },
/* harmony export */   "v2": function() { return /* binding */ fullName; },
/* harmony export */   "vn": function() { return /* binding */ directUploadFile; },
/* harmony export */   "w0": function() { return /* binding */ highlightLinksInText; },
/* harmony export */   "yG": function() { return /* binding */ APPROVAL_TIMES; },
/* harmony export */   "zT": function() { return /* binding */ DATE_FORMAT; }
/* harmony export */ });
/* unused harmony exports EMPTY_SPACE, VISIBLE, ISO_TIME_FORMAT, SHORT_YEAR_FORMAT, repeatTimes, setLocalStorage, getLocalStorage, isMobileApp, getAndClearAfterSignInPath, generateToken */
/* harmony import */ var _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2082);
/* harmony import */ var _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var Buffer = __webpack_require__(74227)["Buffer"];
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var EMPTY_SPACE = "\xa0";
var VISIBLE = (/* unused pure expression or super */ null && ([
    "everyone",
    "group"
]));
var MAX_TEXTAREA_LENGTH = 250;
var ISO_DATE_FORMAT = "YYYY-MM-DD";
var ISO_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
var ISO_TIME_FORMAT_MINUTES = "YYYY-MM-DDTHH:mm";
var ONLY_TIME_FORMAT = "HH:mm";
var DATE_WORD_FORMAT = "D ddd";
var DATE_FORMAT = "DD. MM. YYYY";
var SHORT_YEAR_FORMAT = "HH:MM DD.MM.YY";
var COLORS = [
    "#49BCD6",
    "#FF5B5B",
    "#FFC000",
    "#704FF2"
];
var REDIRECT_URL_REGEX = /\/\S+/;
var MAX_DESCRIPTION_LENGTH = 1000;
var ICON_SIZE = 26;
var REGISTRATION_STEPS = 4;
var APPROVAL_TIMES = [
    {
        value: 6,
        unit: "hours",
        label: "h"
    },
    {
        value: 12,
        unit: "hours",
        label: "h"
    },
    {
        value: 1,
        unit: "days",
        label: "d"
    },
    {
        value: 2,
        unit: "days",
        label: "d"
    },
    {
        value: 3,
        unit: "days",
        label: "d"
    }, 
];
var activityLevels = function(t) {
    return [
        {
            value: "beginner",
            name: t("common:users_activity.levels.beginner"),
            number: 1
        },
        {
            value: "intermediate",
            name: t("common:users_activity.levels.intermediate"),
            number: 2
        },
        {
            value: "experienced",
            name: t("common:users_activity.levels.experienced"),
            number: 3
        }, 
    ];
};
var repeatTimes = function(x) {
    return function(f) {
        if (x > 0) {
            f();
            times(x - 1)(f);
        }
    };
};
var userSetupStatusRedirect = function(setup_status) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    if (!setup_status) return;
    if (setup_status === "created") {
        return "/registration/name";
    } else if (setup_status === "finished") {
        return path;
    } else if (setup_status === "name") {
        return "/registration/name";
    } else if (setup_status === "avatar") {
        return "/registration/photo";
    } else if (setup_status === "info") {
        return "/registration/user_info";
    } else if (setup_status === "info_step2") {
        return "/registration/preferences";
    } else if (setup_status === "preferences") {
        return "/registration/preferences";
    } else {
        return "/registration/finish";
    }
};
var setLocalStorage = function(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.log(e);
    }
};
var getLocalStorage = function(key) {
    var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    try {
        var value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : initialValue;
    } catch (e) {
        return initialValue;
    }
};
var parseUserActivities = function(activities) {
    return activities.map(function(activity) {
        return {
            activity_id: activity.id,
            level: activity.level,
            teacher: activity.teacher
        };
    });
};
var generateEventName = function(event, user, t) {
    var ref, ref1;
    return "".concat((ref = event.activity) === null || ref === void 0 ? void 0 : ref.name, " ").concat(t("common:with"), " ").concat(event.admin_group ? (ref1 = event.admin_group) === null || ref1 === void 0 ? void 0 : ref1.name : user === null || user === void 0 ? void 0 : user.first_name);
};
function copyTextToClipboard(window, text) {
    return _copyTextToClipboard.apply(this, arguments);
}
function _copyTextToClipboard() {
    _copyTextToClipboard = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(window, text) {
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isReactNativeApp(window)) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            type: "COPY_TEXT_TO_CLIPBOARD",
                            text: text
                        }));
                    }
                    if (!("clipboard" in navigator)) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 4;
                    return navigator.clipboard.writeText(text);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 7:
                    return _ctx.abrupt("return", document.execCommand("copy", true, text));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _copyTextToClipboard.apply(this, arguments);
}
var scrollWindowToTop = function() {
    if (true) {
        window.scrollTo(0, 0);
    }
};
var generateRange = function(param) {
    var from = param.from, to = param.to, _step = param.step, step = _step === void 0 ? 1 : _step, _withZero = param.withZero, withZero = _withZero === void 0 ? true : _withZero;
    var result = [];
    for(var i = from; i <= to; i += step){
        withZero && i < 10 ? result.push("0".concat(i)) : result.push("".concat(i));
    }
    return result;
};
var goBack = function(router) {
    var window = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, replace = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (router.query.backLink && router.query.backLink !== "undefined") {
        if (replace) {
            router.replace(router.query.backLink);
        } else {
            router.push(router.query.backLink);
        }
    } else {
        var ref;
        if (window && (window.history.state == null || ((ref = window.history.state) === null || ref === void 0 ? void 0 : ref.idx) == 0)) {
            router.push("/");
        } else {
            router.back();
        }
    }
};
var address = function(obj) {
    return [
        obj.leisure,
        obj.street,
        obj.city
    ].filter(function(key) {
        return key !== null && key !== undefined;
    }).join(", ");
};
var truncate = function(string) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    return string && string.length > length ? string.slice(0, length).concat("...") : string;
};
var getMaxTextLengthByScreen = function(window) {
    if (window == undefined) return;
    var width = window.screen.width;
    if (width <= 375) {
        return parseInt(window.screen.width / 100 * 3);
    } else if (width > 375 && width < 450) {
        return parseInt(window.screen.width / 100 * 5);
    } else {
        return parseInt(window.screen.width / 100 * 6);
    }
};
var isIOSApp = function(userAgent) {
    return userAgent.includes("UnalanuiOSApp");
};
var isAndroidApp = function(userAgent) {
    return userAgent.includes("UnalanuAndroidApp");
};
var isMobileApp = function(userAgent) {
    return userAgent.includes("UnalanuMobileApp");
};
var getAfterSignInPath = function(sessionStorage) {
    var signInPath = sessionStorage.getItem("after_sign_in_path");
    return signInPath ? Buffer.from(signInPath, "base64").toString("utf-8") : null;
};
var getAndClearAfterSignInPath = function(sessionStorage) {
    var signInPath = getAfterSignInPath(sessionStorage);
    if (signInPath && sessionStorage.getItem("after_sign_in_path")) {
        sessionStorage.removeItem("after_sign_in_path");
    }
    return signInPath;
};
var groupNewResourceLink = function(token) {
    var resource = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "events";
    return "/".concat(resource, "/new?group_token=").concat(token, "&backLink=/groups/").concat(token, "/events");
};
var getEmojiByStatus = function(status) {
    if (status === "waiting_approval") {
        return "\uD83D\uDD12 ";
    } else if (status === "invited_by_creator" || status === "invited") {
        return "\u23F3 ";
    } else if (status === "declined") {
        return "\u26D4 ";
    } else if (status === "approved") {
        return "";
    } else if (status === "share_allowed") {
        return "\uD83D\uDCE2 ";
    } else {
        return "";
    }
};
var isReactNativeApp = function(window) {
    return (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && typeof window !== "undefined" && window.ReactNativeWebView;
};
function generateToken(n) {
    var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var token = "";
    for(var i = 0; i < n; i++){
        token += chars[Math.floor(Math.random() * chars.length)];
    }
    return token;
}
function appendURLParam(link, param) {
    return link.includes("?") ? "".concat(link, "&").concat(param) : "".concat(link, "?").concat(param);
}
var isFalsey = function(val) {
    return [
        null,
        undefined
    ].includes(val);
};
var isTruthy = function(val) {
    return !isFalsey(val);
};
var fullName = function(user) {
    if (!user) return "";
    if (user.last_name) {
        return "".concat(user.first_name, " ").concat(user.last_name);
    }
    return user.first_name;
};
var highlightLinksInText = function(text) {
    var regex = /((http|https):\/\/[^\s]+)/g;
    var replacedText = text === null || text === void 0 ? void 0 : text.replace(regex, '<a href="$1" target="_blank">$1</a>');
    return replacedText;
};
var shorten = function(text, maxLength) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
    if (text.length <= maxLength) return text.trim();
    return text.substr(0, text.lastIndexOf(separator, maxLength)).trim();
};
var usersGroupsStatuses = {
    invited: 1,
    invited_by_creator: 2,
    waiting_approval: 3,
    approved: 4,
    declined: 5,
    share_allowed: 6
};
var capitalize = function(string) {
    return string[0].toUpperCase() + string.slice(1);
};
var directUploadFile = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, handleFunction) {
        var DirectUpload, url, upload;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__.e(/* import() */ 3077).then(__webpack_require__.bind(__webpack_require__, 83077));
                case 2:
                    DirectUpload = _ctx.sent.DirectUpload;
                    url = "".concat("https://api.unalanu.com", "/rails/active_storage/direct_uploads");
                    upload = new DirectUpload(file, url);
                    upload.create(handleFunction);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function directUploadFile(file, handleFunction) {
        return _ref.apply(this, arguments);
    };
}();
var langugageEmojiMapper = function(language) {
    var languageEmojis = {
        en: "\uD83C\uDDEC\uD83C\uDDE7",
        cs: "\uD83C\uDDE8\uD83C\uDDFF",
        sk: "\uD83C\uDDF8\uD83C\uDDF0"
    };
    return languageEmojis[language];
};
var setLocaleCookie = function(document, locale) {
    document.cookie = "NEXT_LOCALE=".concat(locale, "; max-age=31536000; path=/");
};


/***/ }),

/***/ 53780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./about-blue.svg": [
		96961,
		6961
	],
	"./back.svg": [
		20061,
		61
	],
	"./bell-big.svg": [
		59735,
		9735
	],
	"./bell.svg": [
		98543,
		8543
	],
	"./calendar-active.svg": [
		58263,
		8263
	],
	"./calendar-big.svg": [
		16709,
		6709
	],
	"./calendar-black.svg": [
		22930,
		2930
	],
	"./calendar-filter.svg": [
		84902,
		4902
	],
	"./calendar.svg": [
		29390,
		9390
	],
	"./challenges.svg": [
		75987,
		5987
	],
	"./chart-bar-big.svg": [
		29967,
		9967
	],
	"./chart-bar.svg": [
		32626,
		2626
	],
	"./chat-big.svg": [
		11561,
		1561
	],
	"./chat.svg": [
		336,
		336
	],
	"./chats-active.svg": [
		7487,
		7487
	],
	"./chats-white.svg": [
		79550,
		9550
	],
	"./chats.svg": [
		20719,
		719
	],
	"./checkbox-off.svg": [
		50709,
		709
	],
	"./checkbox-on.svg": [
		76024,
		6024
	],
	"./close-fill.svg": [
		43682,
		3682
	],
	"./close.svg": [
		62723,
		2723
	],
	"./crosshair.svg": [
		61001,
		1001
	],
	"./culture.svg": [
		29288,
		9288
	],
	"./currency-black.svg": [
		98681,
		8681
	],
	"./currency.svg": [
		30598,
		598
	],
	"./dots-blue.svg": [
		61199,
		1199
	],
	"./dots.svg": [
		29657,
		9657
	],
	"./education.svg": [
		21977,
		1977
	],
	"./filter.svg": [
		3916,
		3916
	],
	"./filter2.svg": [
		6742,
		6742
	],
	"./groups-active.svg": [
		29189,
		9189
	],
	"./groups-big.svg": [
		70845,
		845
	],
	"./groups-blue.svg": [
		56004,
		6004
	],
	"./groups.svg": [
		40494,
		494
	],
	"./hands.svg": [
		95100,
		5100
	],
	"./heart-blue.svg": [
		62330,
		2330
	],
	"./knob-pressed.svg": [
		21844,
		1844
	],
	"./knob.svg": [
		87246,
		7246
	],
	"./location-black.svg": [
		17260,
		7260
	],
	"./location.svg": [
		95558,
		5558
	],
	"./minus-circle-blue.svg": [
		2979,
		2979
	],
	"./minus-circle.svg": [
		56216,
		6216
	],
	"./next.svg": [
		10445,
		445
	],
	"./plus-accent.svg": [
		53493,
		3493
	],
	"./plus-circle-blue.svg": [
		3879,
		3879
	],
	"./plus-circle.svg": [
		46241,
		6241
	],
	"./plus.svg": [
		40019,
		19
	],
	"./position.svg": [
		23537,
		3537
	],
	"./qr-bg.svg": [
		78853,
		8853
	],
	"./qr.svg": [
		61326,
		1326
	],
	"./radio-off.svg": [
		88894,
		8894
	],
	"./radio-on.svg": [
		45615,
		5615
	],
	"./remove.svg": [
		36281,
		6281
	],
	"./repeat-blue.svg": [
		51700,
		1700
	],
	"./search-active.svg": [
		41546,
		1546
	],
	"./search-bg.svg": [
		34177,
		4177
	],
	"./search-big.svg": [
		83509,
		3509
	],
	"./search-blue.svg": [
		53869,
		3869
	],
	"./search-invite.svg": [
		41811,
		1811
	],
	"./search-white.svg": [
		54436,
		4436
	],
	"./search.svg": [
		67478,
		7478
	],
	"./send.svg": [
		86333,
		6333
	],
	"./separator-vertical.svg": [
		21297,
		1297
	],
	"./share-bg.svg": [
		27104,
		7104
	],
	"./share-link.svg": [
		61836,
		1836
	],
	"./slash.svg": [
		43743,
		3743
	],
	"./social.svg": [
		61590,
		1590
	],
	"./sport.svg": [
		30428,
		428
	],
	"./star-blank.svg": [
		78306,
		8306
	],
	"./star.svg": [
		74045,
		4045
	],
	"./time.svg": [
		50895,
		895
	],
	"./unite-avatar.svg": [
		55964,
		5964
	],
	"./user-black.svg": [
		22557,
		2557
	],
	"./user-grey-sm.svg": [
		77137,
		7137
	],
	"./user-white.svg": [
		53607,
		3607
	],
	"./user.svg": [
		65498,
		5498
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53780;
module.exports = webpackAsyncContext;

/***/ })

}]);